import FullScreenLoading from "@/components/FullScreenLoading";
import { AUTH_REDIRECT_URI_STORAGE_KEY } from "@/constants";
import { buildAccountAuthorizeQueryParams } from "@/provider/AuthProvider/accountAuthorize";
import { getRememberedIamAccountId } from "@/store/rememberedAccountsStorage";
import { withAuthenticationRequired } from "react-oidc-context";
import type { PropsWithChildren } from "react";

// Read at module scope: withAuthenticationRequired fixes these args when the HOC is created,
// and nothing writes remembered accounts before the user is authenticated.
const optimisticIamAccountId = getRememberedIamAccountId(
  window.location.pathname
);

const ProtectedRoute = withAuthenticationRequired(
  ({ children }: PropsWithChildren) => children,
  {
    OnRedirecting: () => <FullScreenLoading />,
    onBeforeSignin: () => {
      sessionStorage.setItem(
        AUTH_REDIRECT_URI_STORAGE_KEY,
        `${window.location.pathname}${window.location.search}${window.location.hash}`
      );
    },
    ...(optimisticIamAccountId !== undefined && {
      signinRedirectArgs: {
        extraQueryParams: buildAccountAuthorizeQueryParams(
          optimisticIamAccountId
        ),
      },
    }),
  }
);

export default ProtectedRoute;
